import { watch } from 'vue'
import { useMeta } from 'vue-meta'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const BASE_URL = process.env.VUE_APP_URL || 'https://www.reisebuero-burkhard.de'
const OG_IMAGE = `${BASE_URL}/og-image.png`
const SITE_NAME = 'Reisebüro Burkhard'

export function usePageMeta(state, document) {
  const { meta } = useMeta({})
  const store = useStore()
  const route = useRoute()

  watch(() => state.value, (newState) => {
    if (newState === 'success') {
      const data = document.value.data
      const title = data.meta_title || SITE_NAME
      const description = data.meta_description || ''
      const pageUrl = `${BASE_URL}${route.path}`

      meta.title = title
      meta.description = description

      meta.meta = [
        // Open Graph
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: pageUrl },
        { property: 'og:image', content: OG_IMAGE },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { property: 'og:image:alt', content: title },
        { property: 'og:site_name', content: SITE_NAME },
        { property: 'og:locale', content: 'de_DE' },
        { property: 'og:type', content: 'website' },
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: OG_IMAGE },
        { name: 'twitter:image:alt', content: title },
      ]

      meta.link = [
        { rel: 'canonical', href: pageUrl },
      ]

      // Structured data scripts
      const scripts = []

      // BreadcrumbList (all pages except Home)
      if (route.path !== '/' && route.meta.breadcrumbName) {
        scripts.push({
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Home',
                'item': `${BASE_URL}/`
              },
              {
                '@type': 'ListItem',
                'position': 2,
                'name': route.meta.breadcrumbName,
                'item': pageUrl
              }
            ]
          })
        })
      }

      // Service schema (Reisethema pages only)
      if (route.meta.serviceType) {
        scripts.push({
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            'name': route.meta.serviceType,
            'description': description,
            'provider': {
              '@type': 'TravelAgency',
              '@id': `${BASE_URL}/#organization`
            },
            'areaServed': {
              '@type': 'Country',
              'name': 'DE'
            }
          })
        })
      }

      if (scripts.length) {
        meta.script = scripts
      }

      store.commit('pageTitle/setTitle', title)
    }
  })

  return { meta }
}
